import React, { useState } from 'react';
import { useScoreboard } from './context/ScoreboardContext';
import { useMedia } from './context/MediaContext';

const EntertainmentSettings = () => {
  const { 
    showEntertainmentSettings,
    setShowEntertainmentSettings,
    isEntertainmentEnabled,
  } = useScoreboard();

  const { 
    songs, 
    handleSongUpload, 
    removeSong, 
    youtubeVideos, 
    setYoutubeVideos, 
    youtubePlaylistUrl, 
    setYoutubePlaylistUrl 
  } = useMedia();

  if (!showEntertainmentSettings) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Entertainment Settings</h1>
          <button
            onClick={() => setShowEntertainmentSettings(false)}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        <div className="space-y-6">

          {/* Video Settings */}
          {isEntertainmentEnabled && (
            <div className="mt-8">
              <h2 className="text-lg font-bold mb-4">Pre-Game Videos</h2>
              <div className="space-y-6">
                <div className="space-y-2 mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    YouTube Music Playlist URL
                  </label>
                  <input
                    type="text"
                    placeholder="https://www.youtube.com/playlist?list=..."
                    className="border rounded px-2 py-1 text-sm w-full"
                    value={youtubePlaylistUrl}
                    onChange={(e) => setYoutubePlaylistUrl(e.target.value)}
                  />
                  <p className="text-sm text-gray-500">
                    Enter a YouTube playlist URL to play during pre-game.
                  </p>
                </div>

                {youtubeVideos.map((video, index) => (
                  <div key={index} className="space-y-2">
                    <div className="flex items-center gap-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Video {index + 1}
                      </label>
                      <div className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={video.loop}
                          onChange={(e) => {
                            const newVideos = [...youtubeVideos];
                            newVideos[index] = { ...video, loop: e.target.checked };
                            setYoutubeVideos(newVideos);
                          }}
                          className="rounded border-gray-300 text-blue-600"
                        />
                        <span className="text-sm text-gray-600">Loop video</span>
                      </div>
                    </div>
                    <input
                      type="text"
                      placeholder="https://www.youtube.com/watch?v=..."
                      className="border rounded px-2 py-1 text-sm w-full"
                      value={video.url}
                      onChange={(e) => {
                        const newVideos = [...youtubeVideos];
                        newVideos[index] = { ...video, url: e.target.value };
                        setYoutubeVideos(newVideos);
                      }}
                    />
                  </div>
                ))}
                <p className="text-sm text-gray-500">
                  These videos can be played in the pre-game window. Check the loop option if you want the video to play continuously.
                </p>
              </div>
            </div>
          )}

          {/* Music Management */}
          {isEntertainmentEnabled && (
            <div className="mt-8">
              <h2 className="text-lg font-bold mb-4">In-Game</h2>
              <div className="space-y-4">
                <p className="text-sm text-gray-600">Upload up to 10 MP3 songs that can be played during the game.</p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {songs.map((song, index) => (
                    <div key={index} className="border rounded-lg p-4 space-y-2">
                      <div className="flex items-center justify-between">
                        <span className="text-sm font-medium">Song Slot {index + 1}</span>
                        {song && (
                          <button
                            onClick={() => removeSong(index)}
                            className="text-red-600 hover:text-red-700 text-sm"
                          >
                            Remove
                          </button>
                        )}
                      </div>

                      {song && song.name ? (
                        <div className="text-sm text-gray-600 truncate">{song.name}</div>
                      ) : (
                        <div className="flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg p-4">
                          <label className="cursor-pointer text-center">
                            <span className="text-sm text-gray-500">Click to upload MP3</span>
                            <input
                              type="file"
                              accept="audio/mp3,audio/mpeg"
                              className="hidden"
                              onChange={(e) => {
                                if (e.target.files?.[0]) {
                                  handleSongUpload(index, e.target.files[0]);
                                }
                              }}
                            />
                          </label>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EntertainmentSettings;
